export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/50 via-background-50 to-accent-100/40"></div>

      <div className="relative w-full px-4 md:px-6 py-28 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14 xl:gap-20">
          <div className="flex-1 w-full max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/80 rounded-full mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">漫画全集在线看</span>
              <span className="text-xs text-primary-500">·</span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">免费阅读</span>
              <span className="text-xs text-primary-500">·</span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">全集下载</span>
            </div>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight tracking-tight">
              飞飞漫画网
              <span className="block text-primary-600 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                漫画全集一站式阅读平台
              </span>
            </h1>

            <p className="text-base sm:text-lg text-foreground-600 leading-relaxed mt-4 max-w-xl">
              全网收录，日更不停
            </p>

            <p className="text-sm sm:text-base text-foreground-500 leading-relaxed mt-3 max-w-lg">
              飞飞漫画网为你打造最全面的漫画全集在线看体验。从经典完结漫画到最新热门连载，从热血的日漫经典到崛起的国漫精品——超过5万部漫画资源，涵盖热血、恋爱、悬疑、搞笑、奇幻等全部类型。
              每日同步更新，支持高清漫画全集下载，无论在线追更还是离线畅读，飞飞漫画网都为你提供稳定、纯净、流畅的阅读环境。漫画追更，从这里开始。
            </p>

            <div className="flex flex-wrap items-center gap-5 sm:gap-8 mt-6">
              <div className="flex flex-col">
                <span className="font-heading font-bold text-2xl sm:text-3xl text-primary-600">50,000+</span>
                <span className="text-xs sm:text-sm text-foreground-500">漫画全集收录</span>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="flex flex-col">
                <span className="font-heading font-bold text-2xl sm:text-3xl text-accent-600">每日更新</span>
                <span className="text-xs sm:text-sm text-foreground-500">同步连载追更</span>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="flex flex-col">
                <span className="font-heading font-bold text-2xl sm:text-3xl text-primary-600">2000+</span>
                <span className="text-xs sm:text-sm text-foreground-500">完结漫画大全</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#cards');
                }}
                className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-book-read-line text-lg"></i>
                <span>开始阅读</span>
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-800 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-fire-line text-lg"></i>
                <span>人气排行</span>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-100/30 to-background-50 rounded-2xl blur-xl"></div>
              <div className="relative rounded-xl overflow-hidden bg-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20illustration%20of%20a%20young%20adventurer%20reading%20a%20glowing%20comic%20book%20surrounded%20by%20floating%20manga%20panels%20with%20various%20characters%20and%20scenes%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20magical%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20dreamy%20soft%20lighting%2C%20editorial%20composition%2C%20clean%20simple%20background%20with%20warm%20gradient&width=800&height=900&seq=hero-main-visual&orientation=portrait"
                  alt="飞飞漫画网 - 漫画全集在线看平台主视觉"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/10 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}